/**
 * Definicja gatunku zwierzęcia (np. Pies, Kot)
 */
export class PetSpecies {
  /** Stały klucz systemowy gatunku używany w warunkach logicznych (if/switch). */
  public key: string;

  /** Podstawowa nazwa gatunku. */
  public name: string;

  /** Nazwa specyficzna dla płci męskiej. */
  public maleName: string;

  /** Nazwa specyficzna dla płci żeńskiej. */
  public femaleNam: string;

}
